import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "../Context/Authentication/authContext";
import axios from "axios";
import { baseURL, otherBaseURL } from "../config";
import "./Welcome.scss";
import { Bars } from "react-loader-spinner";
import MapPopup from "./MapPopup";
import {
  TrackingEvents,
  useAnalytics,
} from "../Context/Analytics.context";

import PlaceTwoToneIcon from "@mui/icons-material/PlaceTwoTone";
import HomeIcon from "@mui/icons-material/Home";
import ChaletIcon from "@mui/icons-material/Chalet";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PeopleIcon from "@mui/icons-material/People";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import WelcomeHeader from "./WelcomeHeader";

import Logo from "../assets/slate-logo.svg";
import Florida from "../assets/1.jpg";
import Tennesse from "../assets/2.jpeg";
import Texas from "../assets/3.png";
import California from "../assets/4.jpeg";
import { a11yProps, generateDropDownRanges } from "../Helpers/helpers";
import { DialogTitleProps } from "../SideMenu/SideMenu";
import CloseIcon from "@mui/icons-material/Close";

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    borderBottom: "1px solid #f7b047",
    borderTop: "1px solid #f7b047",
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  "& .MuiDialogTitle-root": {
    color: "#f7b047",
    padding: "10px",
  },
  "& .MuiSvgIcon-root": {
    color: "#f7b047",
  },
  "& .MuiButton-root": {
    color: "#f7b047",
  },
  "& .MuiDialog-paper": {
    maxWidth: "44%",
    background:
      "linear-gradient(0deg, #13223D, #234f70 100%) no-repeat !important",
  },
}));

export const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const Welcome = (): ReactElement => {
  const navigate = useNavigate();
  const { dispatch, state }: any = useContext(authContext);
  const scrollRef = useRef<HTMLInputElement>(null);
  const [projects, setProjects]: any = useState([]);
  const [displayState, setDisplayState]: any = useState(null);
  const [openMap, setOpenMap] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isCityLoading, setIsCityLoading] = useState(false);
  const predictionInfo = state.filters.predictionTill;
  const [isOpen, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [userloading, setUserLoading] = React.useState(false);
  const [showError, setShowError] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [errorMsg, setErrorMessage] = useState("");
  const tabRefs = useRef<(HTMLButtonElement | null)[]>(
    new Array(projects.length).fill(null)
  );
  const { track } = useAnalytics();

  useEffect(() => {
    getAllData();
    getStates();
  }, []);

  useEffect(() => {
    // Ensure the selected tab scrolls into view
    const selectedTabIndex = projects.findIndex(
      (tabItem: any) => tabItem.name === state.filters.state
    );
    const selectedTabRef = tabRefs.current[selectedTabIndex];
    if (selectedTabRef) {
      selectedTabRef.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [state.filters.state, projects, displayState]);

  const getStates = async () => {
    try {
      const response = await axios.get(
        `${baseURL}getState?email=${state.user.email}`
      );
      if (response.data?.length) {
        let temp = response.data?.map((item: any) => {
          return {
            name: item.state,
            coOrd: {
              lat: item.latitude,
              lng: item.longitude,
            },
            abbr: item.abbr,
          };
        });
        let filters = state.filters;
        filters.state = temp[0].name;

        let sortedTemp: any = temp.sort((a: any, b: any) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        dispatch({
          type: "APPLY_FILTER",
          payload: {
            ...filters,
            states: temp,
            stateCord: temp[0].coOrd,
            selectedTerritory: temp[0].name,
            state: temp[0].name,
          },
        });
      } else {
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const addUser = async () => {
    setShowError(false);
    setShowConfirmation(false);
    if (email === "" || firstName === "" || lastName === "") {
      setShowError(true);
      setErrorMessage("😕 Please fill out the empty fields");
      return;
    }
    const payload: any = {
      email: email.toLowerCase(),
      firstname: firstName,
      lastname: lastName,
      role: role,
      contact: phone,
      company: companyName,
    };
    const response = await axios
      .post(`${otherBaseURL}register`, payload)
      .then((responce) => {
        setShowConfirmation(true);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setShowError(true);
        setErrorMessage("😕 Username/Email already exists");
        setLoading(false);
      });
  };

  const handleInputChange = (ev: any) => {
    if (ev.target.name === "email") {
      setShowError(false);
      setEmail(ev.target.value);
    } else if (ev.target.name === "firstName") {
      setShowError(false);
      setFirstName(ev.target.value);
    } else if (ev.target.name === "companyName") {
      setShowError(false);
      setCompanyName(ev.target.value);
    } else if (ev.target.name === "phone") {
      setShowError(false);
      setPhone(ev.target.value);
    } else if (ev.target.name === "lastName") {
      setShowError(false);
      setLastName(ev.target.value);
    } else if (ev.target.name === "role") {
      setShowError(false);
      setRole(ev.target.value);
    }
  };

  const getForms = () => {
    return (
      <form
        className="ftLogin_container_form"
        onSubmit={(ev) => {
          ev.preventDefault();
          addUser();
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Email*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="email"
              value={email}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <div style={{ position: "relative", left: "-20px" }}>
            <Typography
              className="form_label"
              gutterBottom
              style={{ marginLeft: "14px" }}
            >
              Role*
            </Typography>
            <Select
              value={role}
              label="Select value as"
              onChange={handleInputChange}
              name="role"
              className="role_dropdown"
              autoComplete="off"
            >
              <MenuItem value={"user"}>User</MenuItem>
              <MenuItem value={"admin"}>Admin</MenuItem>
            </Select>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              First Name*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="firstName"
              value={firstName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Last Name*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="lastName"
              value={lastName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Company Name(optional)
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="companyName"
              value={companyName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Phone(optional)
            </Typography>
            <OutlinedInput
              type="number"
              className="form_input_name"
              name="phone"
              value={phone}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
        </div>

        <FormControl
          sx={{ m: 2 }}
          style={{ margin: "12px", display: "flex", alignItems: "center" }}
        >
          <Button
            variant="outlined"
            // onClick={() => login()}
            type="submit"
            className="loginButton"
          >
            Add Account
            <Bars
              height="30"
              color="#035F77"
              ariaLabel="bars-loading"
              wrapperStyle={{ float: "left" }}
              wrapperClass=""
              visible={userloading}
            />
          </Button>
        </FormControl>

        {showConfirmation && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText id="accountId-error">
                Invitation sent Successfully
              </FormHelperText>
            </FormControl>
          </div>
        )}

        {showError && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText error id="accountId-error">
                {errorMsg}
              </FormHelperText>
            </FormControl>
          </div>
        )}
      </form>
    );
  };

  const getAllData = async () => {
    const predictionInfo: any = await generateDropDownRanges();
    const results: any[] = [];
    const endpoints: string[] = [];
    const response = await axios.get(
      `${baseURL}getState?email=${state.user.email}`
    );
    let selectedDate = "2023-02";
    if (response.data?.length) {
      let temp = response.data?.map((item: any) => {
        const stateName = item.state.toLowerCase();
        // @ts-ignore
        const date = predictionInfo[stateName].cityPredValues[0];
        selectedDate = date;
        endpoints.push(
          `${baseURL}getCityPredictions?state=${item.state}&date=${date}`
        );
        return {
          name: item.state,
          coOrd: {
            lat: item.latitude,
            lng: item.longitude,
          },
          abbr: item.abbr,
        };
      });
      let filters = state.filters;
      filters.state = temp[0].name;
      let sortedTemp: any = temp.sort((a: any, b: any) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      setProjects(sortedTemp.reverse());
      dispatch({
        type: "APPLY_FILTER",
        payload: {
          ...filters,
          states: sortedTemp,
          stateCord: sortedTemp[sortedTemp.length - 1],
          selectedTerritory: sortedTemp[sortedTemp.length - 1].name,
          profitability: "All Zipcodes",
          state: sortedTemp[sortedTemp.length - 1].name,
          predictionTill: predictionInfo,
          showHeatMap: true,
          showFloodMap: false,
          showFireMap: false,
          showSchoolMap: false,
          showHurricaneMap: false,
          predictionFor:
            predictionInfo[sortedTemp[sortedTemp.length - 1].name.toLowerCase()]
              .cityPredValues[0],
          zipcodeQuarterPredictionFor:
            predictionInfo[sortedTemp[sortedTemp.length - 1].name.toLowerCase()]
              .zipcodePredValues[0],
          quarterPredictionFor:
            predictionInfo[sortedTemp[sortedTemp.length - 1].name.toLowerCase()]
              .cityPredValues[0],
        },
      });
      const predictionData = await axios.get(
        `${baseURL}getCityPredictions?state=${
          sortedTemp[sortedTemp.length - 1].name
        }&date=${
          predictionInfo[sortedTemp[sortedTemp.length - 1].name.toLowerCase()]
            .cityPredValues[0]
        }`
      );
      const selectedState = predictionData?.data?.state;
      const data = predictionData?.data?.cube;
      const ppsf = [...sort_data(data, "ppsf")];

      const homeSalesMean = [...sort_data(data, "homeSalesMean")];
      const homeSalesCumulativeMean = [
        ...sort_data(data, "home_sales_cumulative_mean"),
      ];
      const population = [...sort_data(data, "population_2021")];
      results.push({
        name: selectedState,
        ppfs: ppsf[0].ppsf,
        ppfsCity: ppsf[0].city,
        homeSalesMean: homeSalesMean[0].homeSalesMean,
        homeSalesMeanCity: homeSalesMean[0].city,
        homeSalesCumulativeMean:
          homeSalesCumulativeMean[0].home_sales_cumulative_mean,
        homeSalesCumulativeMeanCity: homeSalesCumulativeMean[0].city,
        population: population[0].population_2021,
        populationCity: population[0].city,
      });
      setDisplayState(results[0]);
      setLoading(false);
      // if (index === 0) setDisplayState(results[0])
    }

    // Promise.all(endpoints.map((endpoint) => axios.get(endpoint))).then((responses) => {
    //     responses.forEach((resp, index) => {
    // const selectedState = resp?.data?.state
    // const data = resp?.data?.cube
    // const ppsf = [...sort_data(data, 'ppsf')]

    // const homeSalesMean = [...sort_data(data, 'homeSalesMean')]
    // const homeSalesCumulativeMean = [...sort_data(data, 'home_sales_cumulative_mean')]
    // const population = [...sort_data(data, 'population_2021')]
    // results.push({
    //     name: selectedState,
    //     ppfs: ppsf[0].ppsf,
    //     ppfsCity: ppsf[0].city,
    //     homeSalesMean: homeSalesMean[0].homeSalesMean,
    //     homeSalesMeanCity: homeSalesMean[0].city,
    //     homeSalesCumulativeMean: homeSalesCumulativeMean[0].home_sales_cumulative_mean,
    //     homeSalesCumulativeMeanCity: homeSalesCumulativeMean[0].city,
    //     population: population[0].population_2021,
    //     populationCity: population[0].city

    // })
    // // if (index === 0) setDisplayState(results[0])
    //     });

    //     setLoading(false)
    // });
  };

  const sort_data = (arr: any, type: string) => {
    return arr.sort((a: any, b: any) => Number(b[type]) - Number(a[type]));
  };

  const onClickProject = async (projectName: any) => {
    const results: any = [];
    setIsCityLoading(true);
    const predictionData = await axios.get(
      `${baseURL}getCityPredictions?state=${projectName}&date=${
        state.filters.predictionTill[projectName.toLowerCase()]
          .cityPredValues[0]
      }`
    );
    const selectedState = predictionData?.data?.state;
    const data = predictionData?.data?.cube;
    const ppsf = [...sort_data(data, "ppsf")];

    const homeSalesMean = [...sort_data(data, "homeSalesMean")];
    const homeSalesCumulativeMean = [
      ...sort_data(data, "home_sales_cumulative_mean"),
    ];
    const population = [...sort_data(data, "population_2021")];
    results.push({
      name: selectedState,
      ppfs: ppsf[0].ppsf,
      ppfsCity: ppsf[0].city,
      homeSalesMean: homeSalesMean[0].homeSalesMean,
      homeSalesMeanCity: homeSalesMean[0].city,
      homeSalesCumulativeMean:
        homeSalesCumulativeMean[0].home_sales_cumulative_mean,
      homeSalesCumulativeMeanCity: homeSalesCumulativeMean[0].city,
      population: population[0].population_2021,
      populationCity: population[0].city,
    });
    setDisplayState(results[0]);

    let filters = state.filters;
    const temp = filters.states.find((s: any) => s.name === projectName);
    filters.state = temp.name;
    dispatch({
      type: "APPLY_FILTER",
      payload: {
        ...filters,
        stateCord: temp,
        selectedTerritory: temp.name,
        profitability: "All Zipcodes",
        state: temp.name,
        showHeatMap: true,
        showFloodMap: false,
        showFireMap: false,
        showSchoolMap: false,
        showHurricaneMap: false,
      },
    });
    setIsCityLoading(false);
  };
  const handleCloseDialog = () => {
    setOpen(false);
    setEmail("");
    setRole("");
    setFirstName("");
    setLastName("");
    setShowConfirmation(false);
    setShowError(false);
  };
  const handleAddUser = () => {
    setOpen(true);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onClickProject(newValue);

    // if (!ADJUSTED_PREDICTIONS.includes(newValue)) {
    //   dispatch({
    //     type: 'APPLY_FILTER',
    //     payload: {
    //       ...state.filters,
    //       adjustedPredictions: false,
    //       submitAdjustedPrediction: false,
    //       refreshAdjustedPredictionSubmit: false
    //     },
    //   });
    // }
  };

  return isLoading ? (
    <div className="welcome_main">
      <div className="landing-page" ref={scrollRef}>
        {displayState?.name === "Florida" ? (
          <img src={Florida} alt="weather" className="image-frame" />
        ) : displayState?.name === "Texas" ? (
          <img src={Texas} alt="weather" className="image-frame" />
        ) : displayState?.name === "California" ? (
          <img src={California} alt="weather" className="image-frame" />
        ) : displayState?.name === "Tennessee" ? (
          <img src={Tennesse} alt="weather" className="image-frame" />
        ) : (
          <img src={Florida} alt="weather" className="image-frame" />
        )}
        <WelcomeHeader />
        <Bars
          height="400"
          ariaLabel="bars-loading"
          wrapperClass="spinner-progress-bar"
          visible={true}
        />
      </div>
    </div>
  ) : (
    <div className="welcome_main">
      <div className="landing-page" ref={scrollRef}>
        {displayState?.name === "Florida" ? (
          <img src={Florida} alt="weather" className="image-frame" />
        ) : displayState?.name === "Texas" ? (
          <img src={Texas} alt="weather" className="image-frame" />
        ) : displayState?.name === "California" ? (
          <img src={California} alt="weather" className="image-frame" />
        ) : (
          <img src={Tennesse} alt="weather" className="image-frame" />
        )}

        <WelcomeHeader addUser={handleAddUser} />
        <div className="left-panel">
          <Box className="welcome-menuContainer">
            <Tabs
              value={state.filters.state}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              selectionFollowsFocus
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#fff",
                },
              }}
            >
              {projects.map((tabItem: any, i: number) => {
                if (!tabRefs.current[i]) {
                  tabRefs.current[i] = null; // Ensure the ref array has consistent indices
                }
                return (
                  <Tab
                    key={tabItem.name}
                    className={`vertical-title ${
                      displayState.name === tabItem.name
                        ? "vertical-selected"
                        : ""
                    }`}
                    value={tabItem.name}
                    onClick={(event) => {
                      // Prevent default behavior
                      event.preventDefault();
                      // Call the onClickProject function directly
                      onClickProject(tabItem.name);
                    }}
                    ref={(el) => (tabRefs.current[i] = el)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                    label={
                      tabItem.name.charAt(0).toUpperCase() +
                      tabItem.name.slice(1).toLowerCase()
                    }
                    style={{
                      backgroundColor:
                        state?.filters.state === tabItem.name ? "" : "",
                      borderRadius:
                        state?.filters.state === tabItem.name ? "4px" : "",
                      fontWeight:
                        state?.filters.state === tabItem.name
                          ? "bold"
                          : "normal",
                      color:
                        state?.filters.state === tabItem.name
                          ? "wheat"
                          : "#fff",
                    }}
                    {...a11yProps(i)}
                  />
                );
              })}
            </Tabs>
          </Box>
          {/* {projects.map(
                        (project: any) =>
                            <div
                                key={project.name}
                                className={`vertical-title ${displayState.name === project.name ? 'vertical-selected' : ''}`}
                                onClick={() => onClickProject(project.name)}
                            >
                                {project.name === 'Tennesse' ? 'Tennessee' : project.name}
                            </div>
                    )} */}
        </div>
        <div className="right-panel">
          {isCityLoading ? (
            <div style={{ marginLeft: "35%", marginTop: "15%" }}>
              {" "}
              <Bars
                height="400"
                ariaLabel="bars-loading"
                wrapperClass="spinner-progress-bar"
                visible={true}
              />
            </div>
          ) : (
            <>
              <div>
                <div
                  className="city-location"
                  onClick={() => {
                    setOpenMap(true);
                  }}
                >
                  <PlaceTwoToneIcon className="icon-position" />
                  <Typography variant="h6">
                    {displayState.name === "Tennesse"
                      ? "Tennessee"
                      : displayState.name}{" "}
                    Heat Map
                  </Typography>
                </div>
                <div
                  className="state-heading"
                  onClick={() => {
                    track(TrackingEvents["state-selected"], {
                      state: displayState.name,
                    });
                    navigate("/home");
                  }}
                >
                  <Typography variant="h1" className="">
                    {displayState.name === "Tennesse"
                      ? "Tennessee"
                      : displayState.name}
                  </Typography>
                </div>
              </div>

              <div className="right-side-panel">
                <div className="detail-box">
                  <div className="detail-title">
                    <AttachMoneyIcon /> &nbsp; PPSF
                  </div>
                  <div className="detail-value">
                    <Typography variant="h6" className="value-h6">
                      Value:
                    </Typography>
                    <label>{displayState.ppfs}</label>
                  </div>
                  <div className="detail-city">
                    <Typography variant="h6" className="value-h6">
                      City:
                    </Typography>
                    <label>{displayState.ppfsCity}</label>
                  </div>
                </div>
                <div className="detail-box">
                  <div className="detail-title">
                    <HomeIcon /> &nbsp; Home Sales Mean
                  </div>
                  <div className="detail-value">
                    <Typography variant="h6" className="value-h6">
                      Value:
                    </Typography>
                    <label>{displayState.homeSalesMean}</label>
                  </div>
                  <div className="detail-city">
                    <Typography variant="h6" className="value-h6">
                      City:
                    </Typography>
                    <label>{displayState.homeSalesMeanCity}</label>
                  </div>
                </div>
                <div className="detail-box">
                  <div className="detail-title">
                    <ChaletIcon /> &nbsp; Home Sales Cumulative Mean
                  </div>
                  <div className="detail-value">
                    <Typography variant="h6" className="value-h6">
                      Value:
                    </Typography>
                    <label>{displayState.homeSalesCumulativeMean}</label>
                  </div>
                  <div className="detail-city">
                    <Typography variant="h6" className="value-h6">
                      City:
                    </Typography>
                    <label>{displayState.homeSalesCumulativeMeanCity}</label>
                  </div>
                </div>
                <div className="detail-box">
                  <div className="detail-title">
                    <PeopleIcon /> &nbsp; Population <span>(As 2021)</span>
                  </div>
                  <div className="detail-value">
                    <Typography variant="h6" className="value-h6">
                      Value:
                    </Typography>
                    <label>{displayState.population}</label>
                  </div>
                  <div className="detail-city">
                    <Typography variant="h6" className="value-h6">
                      City:
                    </Typography>
                    <label>{displayState.populationCity}</label>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <MapPopup open={openMap} close={() => setOpenMap(false)} />
      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseDialog}
        >
          <div style={{ textAlign: "center" }}>
            <img
              id="Header-Logo"
              alt="header-logo"
              src={Logo}
              className="header-logo"
              height="80px"
              width="70px"
              onClick={() => navigate("/")}
            />
            <p style={{ padding: 0, margin: 0, marginTop: "-8px" }}>
              {" "}
              Add Account
            </p>
          </div>
        </BootstrapDialogTitle>
        <DialogContent dividers>{getForms()}</DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default Welcome;